function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailEditorImageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 520 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "imageIcon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M302.91,183.68V117.57a9.47,9.47,0,0,0-9.44-9.44H227.36a9.47,9.47,0,0,0-9.45,9.44v66.11a9.47,9.47,0,0,0,9.45,9.45h66.11A9.47,9.47,0,0,0,302.91,183.68Zm-59-26,11.8,14.22,16.53-21.3L293.47,179H227.36Z",
    style: {
      fill: "#9a9a9a"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailEditorImageIcon);
export default __webpack_public_path__ + "static/media/emailEditorImageIcon.e3f1893f18b56d0da2c3d27198653f4d.svg";
export { ForwardRef as ReactComponent };